import { render, staticRenderFns } from "./exchange-group-order-detail.vue?vue&type=template&id=3135a894"
import script from "./exchange-group-order-detail.vue?vue&type=script&lang=js"
export * from "./exchange-group-order-detail.vue?vue&type=script&lang=js"
import style0 from "./exchange-group-order-detail.vue?vue&type=style&index=0&id=3135a894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports